import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import StockReorderPlanningReportActions, {
  StockReorderPlanningReportTypes
} from '../Stores/StockReorderPlanningReport/Actions';

const getAppStore = state => state.app;

export function* stockReorderPlanningReportInitStockReorderPlanning() {
  try {
    yield put(StockReorderPlanningReportActions.stockReorderPlanningReportReportLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `whseReport/initStockReorderPlanning/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        StockReorderPlanningReportActions.stockReorderPlanningReportInitStockReorderPlanningSuccess(
          result.data
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(StockReorderPlanningReportActions.stockReorderPlanningReportReportLoading(false));
  }
}

export function* stockReorderPlanningReportStockReorderPlanning({ formikBag, criteria }) {
  try {
    formikBag.setSubmitting(true);
    yield put(StockReorderPlanningReportActions.stockReorderPlanningReportReportLoading(true));

    const objCriteria = {};
    if ('company_ids_select2' in criteria) {
      const values = criteria.company_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.company_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('item_ids_select2' in criteria) {
      const values = criteria.item_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.item_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('item_group_01_ids_select2' in criteria) {
      const values = criteria.item_group_01_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.item_group_01_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('item_group_02_ids_select2' in criteria) {
      const values = criteria.item_group_02_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.item_group_02_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('item_group_03_ids_select2' in criteria) {
      const values = criteria.item_group_03_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.item_group_03_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('location_ids_select2' in criteria) {
      const values = criteria.location_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.location_ids = values.map(entry => {
          return entry.value;
        });
      }
    }

    let columns = [];
    if (criteria.columns.target.length > 0) {
      columns = criteria.columns.target.map(entry => {
        return entry.column;
      });
    }

    const app = yield select(getAppStore);
    const postData = {
      sorts: [],
      criteria: objCriteria,
      columns
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `whseReport/stockReorderPlanning/${app.curSiteFlowId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(
        StockReorderPlanningReportActions.stockReorderPlanningReportStockReorderPlanningSuccess(
          criteria,
          result.data.data
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(StockReorderPlanningReportActions.stockReorderPlanningReportReportLoading(false));
  }
}

export function* stockReorderPlanningReportFetchItemOptions({ search }) {
  try {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemOptionLoading(true)
    );

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `item/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(
        StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemOptionSuccess(options)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemOptionLoading(false)
    );
  }
}

export function* stockReorderPlanningReportFetchItemGroup01Options({ search }) {
  try {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemGroup01OptionLoading(
        true
      )
    );

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `itemGroup01/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(
        StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemGroup01OptionSuccess(
          options
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemGroup01OptionLoading(
        false
      )
    );
  }
}

export function* stockReorderPlanningReportFetchItemGroup02Options({ search }) {
  try {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemGroup02OptionLoading(
        true
      )
    );

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `itemGroup02/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(
        StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemGroup02OptionSuccess(
          options
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemGroup02OptionLoading(
        false
      )
    );
  }
}

export function* stockReorderPlanningReportFetchItemGroup03Options({ search }) {
  try {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemGroup03OptionLoading(
        true
      )
    );

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `itemGroup03/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(
        StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemGroup03OptionSuccess(
          options
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchItemGroup03OptionLoading(
        false
      )
    );
  }
}

export function* stockReorderPlanningReportFetchLocationOptions({ search }) {
  try {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchLocationOptionLoading(true)
    );

    const app = yield select(getAppStore);
    const postData = {
      siteFlowId: app.curSiteFlowId,
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `location/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(
        StockReorderPlanningReportActions.stockReorderPlanningReportFetchLocationOptionSuccess(
          options
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchLocationOptionLoading(false)
    );
  }
}

export function* stockReorderPlanningReportFetchCompanyOptions({ search }) {
  try {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchCompanyOptionLoading(true)
    );

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `company/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} - ${d.name_01}`
      }));

      yield put(
        StockReorderPlanningReportActions.stockReorderPlanningReportFetchCompanyOptionSuccess(
          options
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      StockReorderPlanningReportActions.stockReorderPlanningReportFetchCompanyOptionLoading(false)
    );
  }
}

export const saga = [
  takeLatest(
    StockReorderPlanningReportTypes.STOCK_REORDER_PLANNING_REPORT_INIT_STOCK_REORDER_PLANNING,
    stockReorderPlanningReportInitStockReorderPlanning
  ),
  takeLatest(
    StockReorderPlanningReportTypes.STOCK_REORDER_PLANNING_REPORT_STOCK_REORDER_PLANNING,
    stockReorderPlanningReportStockReorderPlanning
  ),
  takeLatest(
    StockReorderPlanningReportTypes.STOCK_REORDER_PLANNING_REPORT_FETCH_COMPANY_OPTIONS,
    stockReorderPlanningReportFetchCompanyOptions
  ),
  takeLatest(
    StockReorderPlanningReportTypes.STOCK_REORDER_PLANNING_REPORT_FETCH_ITEM_OPTIONS,
    stockReorderPlanningReportFetchItemOptions
  ),
  takeLatest(
    StockReorderPlanningReportTypes.STOCK_REORDER_PLANNING_REPORT_FETCH_ITEM_GROUP01_OPTIONS,
    stockReorderPlanningReportFetchItemGroup01Options
  ),
  takeLatest(
    StockReorderPlanningReportTypes.STOCK_REORDER_PLANNING_REPORT_FETCH_ITEM_GROUP02_OPTIONS,
    stockReorderPlanningReportFetchItemGroup02Options
  ),
  takeLatest(
    StockReorderPlanningReportTypes.STOCK_REORDER_PLANNING_REPORT_FETCH_ITEM_GROUP03_OPTIONS,
    stockReorderPlanningReportFetchItemGroup03Options
  ),
  takeLatest(
    StockReorderPlanningReportTypes.STOCK_REORDER_PLANNING_REPORT_FETCH_LOCATION_OPTIONS,
    stockReorderPlanningReportFetchLocationOptions
  )
];
